import { render, staticRenderFns } from "./MessageWorkerRelativeList.vue?vue&type=template&id=6f164679&scoped=true&"
import script from "./MessageWorkerRelativeList.vue?vue&type=script&lang=ts&"
export * from "./MessageWorkerRelativeList.vue?vue&type=script&lang=ts&"
import style0 from "./MessageWorkerRelativeList.vue?vue&type=style&index=0&id=6f164679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f164679",
  null
  
)

export default component.exports